import { DatabaseManager } from "../services/DatabaseManager";
import { Participant } from "../types/participant";
import { Patient } from "../types/patient";
import { PARTICIPANT_LINK, WARNING } from "../util/const";


const LinkingHelper = async (patient: Patient, participant: Participant): Promise<boolean> => {

  const ConfirmMatch = (patient: Patient, participant: Participant): boolean => {

    var dobCheck = false;
    if(participant.birthDate !== undefined && patient.birthDate !== undefined)
      dobCheck = Date.parse(participant.birthDate) === Date.parse(patient.birthDate);
  
    var firstnameCheck = false;
    if(participant.givenName !== undefined && patient.givenNames !== undefined)
      firstnameCheck = participant.givenName.toLowerCase() === patient.givenNames.toString().toLowerCase();
  
    var lastnameCheck = false;
    if(participant.familyName !== undefined && patient.familyName !== undefined)
      lastnameCheck = participant.familyName.toLowerCase() === patient.familyName.toLowerCase();
  
    var falseCount = 0;
    if (!dobCheck) falseCount++;
    if (!firstnameCheck) falseCount++;
    if (!lastnameCheck) falseCount++;
  
    var confirmed = true
    if(falseCount !== 0)
      confirmed = window.confirm(WARNING)
  
    return confirmed;
  }

  let linked = false;
  if(patient === undefined || participant === undefined)
    return linked;
 
  let confirmed = ConfirmMatch(patient, participant)
  if(confirmed)
  {
    participant.resourceId = patient.resourceId;
    participant.studyId = patient.studyId;
    await DatabaseManager.getInstance().put(PARTICIPANT_LINK, participant)
    .then((response) => {
      linked = true;
    })
    .catch((error) => {
      console.error(error);
    });
  }
  return linked;
}
export default LinkingHelper;